// imports
import React from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// local imports
import { uiActions } from '../../../store';
import CustomButton from '../../CustomButton';
import { sharedTooltipProps } from '../CustomMapControls/sharedTooltipProps';

/**
 * InfoButton
 *
 * Renders a button that toggles the info dialog in the application.
 *
 * @returns {JSX.Element} The rendered InfoButton component.
 */
const InfoButton = React.memo(function InfoButton() {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(uiActions.toggleInfoDialog());
  };

  return (
    <Tooltip title="Info" placement="left" {...sharedTooltipProps}>
      <CustomButton
        data-testid="info-button"
        aria-label="Info"
        onClick={handleClick}
        buttonVariant="standalone"
      >
        <InfoOutlinedIcon />
      </CustomButton>
    </Tooltip>
  );
});

export default InfoButton;
